/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Achievements_LoadingInputs */

const id_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat...`)
};

const ms_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat...`)
};

const da_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlæser...`)
};

const de_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lädt...`)
};

const en_us2_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const es_es2_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const es_mx2_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const fil_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naglo-load...`)
};

const fr_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement…`)
};

const it_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento...`)
};

const hu_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betöltés...`)
};

const nl_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden...`)
};

const no_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laster...`)
};

const pl_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ładowanie...`)
};

const pt_br2_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando...`)
};

const pt_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar...`)
};

const ro_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se încarcă...`)
};

const fi_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladataan...`)
};

const sv_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar...`)
};

const vi_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải...`)
};

const tr_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yükleniyor...`)
};

const cs_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítání...`)
};

const bg_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зареждане...`)
};

const ru_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка...`)
};

const uk_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантаження...`)
};

const ar_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ التحميل...`)
};

const hi_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लोड हो रहा है...`)
};

const th_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลด...`)
};

const ja_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込み中...`)
};

const zh_cn2_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载中...`)
};

const zh_hant1_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`載入中...`)
};

const ko_profile_achievements_loading = /** @type {(inputs: Profile_Achievements_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로딩 중...`)
};

/**
* | output |
* | --- |
* | "Loading..." |
*
* @param {Profile_Achievements_LoadingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_achievements_loading = /** @type {((inputs?: Profile_Achievements_LoadingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Achievements_LoadingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_achievements_loading(inputs)
	if (locale === "ms") return ms_profile_achievements_loading(inputs)
	if (locale === "da") return da_profile_achievements_loading(inputs)
	if (locale === "de") return de_profile_achievements_loading(inputs)
	if (locale === "en-US") return en_us2_profile_achievements_loading(inputs)
	if (locale === "es-ES") return es_es2_profile_achievements_loading(inputs)
	if (locale === "es-MX") return es_mx2_profile_achievements_loading(inputs)
	if (locale === "fil") return fil_profile_achievements_loading(inputs)
	if (locale === "fr") return fr_profile_achievements_loading(inputs)
	if (locale === "it") return it_profile_achievements_loading(inputs)
	if (locale === "hu") return hu_profile_achievements_loading(inputs)
	if (locale === "nl") return nl_profile_achievements_loading(inputs)
	if (locale === "no") return no_profile_achievements_loading(inputs)
	if (locale === "pl") return pl_profile_achievements_loading(inputs)
	if (locale === "pt-BR") return pt_br2_profile_achievements_loading(inputs)
	if (locale === "pt") return pt_profile_achievements_loading(inputs)
	if (locale === "ro") return ro_profile_achievements_loading(inputs)
	if (locale === "fi") return fi_profile_achievements_loading(inputs)
	if (locale === "sv") return sv_profile_achievements_loading(inputs)
	if (locale === "vi") return vi_profile_achievements_loading(inputs)
	if (locale === "tr") return tr_profile_achievements_loading(inputs)
	if (locale === "cs") return cs_profile_achievements_loading(inputs)
	if (locale === "bg") return bg_profile_achievements_loading(inputs)
	if (locale === "ru") return ru_profile_achievements_loading(inputs)
	if (locale === "uk") return uk_profile_achievements_loading(inputs)
	if (locale === "ar") return ar_profile_achievements_loading(inputs)
	if (locale === "hi") return hi_profile_achievements_loading(inputs)
	if (locale === "th") return th_profile_achievements_loading(inputs)
	if (locale === "ja") return ja_profile_achievements_loading(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_achievements_loading(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_achievements_loading(inputs)
	return ko_profile_achievements_loading(inputs)
});
export { profile_achievements_loading as "profile.achievements.loading" }